module.exports = __webpack_public_path__ + "static/media/ios-link.153963b9.svg";